/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request for create a timeslot
 * @export
 * @interface CreateTimeslotsRequest
 */
export interface CreateTimeslotsRequest {
    /**
     * Start date of timeslot
     * @type {string}
     * @memberof CreateTimeslotsRequest
     */
    startDate?: string;
    /**
     * End date of timeslot
     * @type {string}
     * @memberof CreateTimeslotsRequest
     */
    endDate?: string;
    /**
     * Frequency to apply a timeslot
     * @type {string}
     * @memberof CreateTimeslotsRequest
     */
    frequency?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateTimeslotsRequest
     */
    weekModelIds?: Array<string>;
}

/**
 * Check if a given object implements the CreateTimeslotsRequest interface.
 */
export function instanceOfCreateTimeslotsRequest(value: object): value is CreateTimeslotsRequest {
    return true;
}

export function CreateTimeslotsRequestFromJSON(json: any): CreateTimeslotsRequest {
    return CreateTimeslotsRequestFromJSONTyped(json, false);
}

export function CreateTimeslotsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateTimeslotsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'startDate': json['startDate'] == null ? undefined : json['startDate'],
        'endDate': json['endDate'] == null ? undefined : json['endDate'],
        'frequency': json['frequency'] == null ? undefined : json['frequency'],
        'weekModelIds': json['weekModelIds'] == null ? undefined : json['weekModelIds'],
    };
}

export function CreateTimeslotsRequestToJSON(json: any): CreateTimeslotsRequest {
    return CreateTimeslotsRequestToJSONTyped(json, false);
}

export function CreateTimeslotsRequestToJSONTyped(value?: CreateTimeslotsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'startDate': value['startDate'],
        'endDate': value['endDate'],
        'frequency': value['frequency'],
        'weekModelIds': value['weekModelIds'],
    };
}

